export default __webpack_public_path__ + "9fe6aafdb848ce931ba0655a3c91e997.png";